export default "__VITE_ASSET__CaU0FdFv__"